import { useEffect } from "react";

/**
 * Injects a JSON-LD <script> into document.head and removes it on unmount.
 * Multiple instances per page are supported (use unique `id`).
 */
export default function Jsonld({ id, data }) {
  useEffect(() => {
    const tag = document.createElement("script");
    tag.type = "application/ld+json";
    tag.id = id;
    tag.textContent = JSON.stringify(data);
    // Remove any pre-existing tag with the same id
    const existing = document.getElementById(id);
    if (existing && existing.parentNode) existing.parentNode.removeChild(existing);
    document.head.appendChild(tag);
    return () => {
      if (tag.parentNode) tag.parentNode.removeChild(tag);
    };
  }, [id, data]);
  return null;
}

/**
 * Sets <title> + meta description for the current view. Restores on unmount.
 */
export function SeoMeta({ title, description }) {
  useEffect(() => {
    const prevTitle = document.title;
    if (title) document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    let prevDesc = "";
    if (meta && description) {
      prevDesc = meta.getAttribute("content") || "";
      meta.setAttribute("content", description);
    }
    return () => {
      document.title = prevTitle;
      if (meta && description) meta.setAttribute("content", prevDesc);
    };
  }, [title, description]);
  return null;
}
